import { Center } from "@/components/Center/Center";
import { useNavigate } from "react-router-dom";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Center>
      <div className="flex flex-col items-center justify-center gap-6 px-4">
        <img src="/assets/miranyan-error.svg" alt="Error" className="w-32 h-32 mb-2" />

        <div className="flex flex-col items-center gap-2">
          <h1 className="text-6xl font-bold text-gray-800">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700">ページが見つかりません</h2>
        </div>

        <p className="text-center text-gray-600 max-w-md">
          お探しのページは存在しないか、移動または削除された可能性があります。
        </p>

        <button
          type="button"
          onClick={() => navigate("/")}
          className="px-6 py-3 bg-[#4B57FF] text-white rounded-full hover:bg-[#3A46CC] transition-colors duration-200"
        >
          ホームに戻る
        </button>
      </div>
    </Center>
  );
};
